import * as ActionTypes from '../../constants/actionTypes';
// import {errorBox_Show, toggle_modal} from "../../actions/A_Popups";

export const setWorkSheetsActiveIndex = (workSheetsActiveIndex) => ({
  type: ActionTypes.DISCOUNTS_SET_WORKSHEETS_ACTIVE_INDEX,
  payload: { workSheetsActiveIndex }
});

// export const toggleEnableWorksheet = (enableWorksheet) => ({
//   type: ActionTypes.DISCOUNTS_TOGGLE_ENABLE_WORKSHEET,
//   payload: {
//     enableWorksheet
//   }
// });
// export const toggleEnableWorksheetForClients = (enableWorksheetForClients) => ({
//   type: ActionTypes.DISCOUNTS_TOGGLE_ENABLE_WORKSHEET_FOR_CLIENTS,
//   payload: {
//     enableWorksheetForClients
//   }
// });

export const resetDiscounts = () => ({
  type: ActionTypes.DISCOUNTS_SECTIONS_RESET
});

export const setDiscountsReceived = (discountSections) => ({
  type: ActionTypes.DISCOUNTS_SECTIONS_REQUEST_SUCCESS,
  payload: {
    discountSections
  }
});

export const setDiscountSections = (discountSections) => {
  return (dispatch) => {
    discountSections = discountSections.map(discountSection => {
      if (!discountSection.discounts) {
        discountSection.discounts = [];
      }
      if ((discountSection.discounts.length === 2) && (discountSection.discounts[0].mode !== discountSection.discounts[1].mode)) {
        const firstModeValue = discountSection.discounts[0].mode;
        discountSection.discounts.forEach(discount => {
          discount.mode = firstModeValue
        });
      }
      return discountSection
    })
    dispatch({
      type: ActionTypes.DISCOUNTS_SET_SECTIONS, // update frontend!
      payload: { discountSections }
    });
  }
};

// add type here and store in discounts reducer if needed
export const setWorkSheetsCount = (workSheetsCount) => ({
  type: ActionTypes.DISCOUNTS_SET_WORKSHEET_COUNT,
  payload: {workSheetsCount}
});

export const setWorkSheetWizardSelections = (workSheetWizardSelectionsActive = false,
                                             workSheetWizardSelectionsGroupSelected = null,
                                             workSheetWizardSelectionsClick = null) => ({
  type: ActionTypes.DISCOUNTS_SET_WIZARD_SELECTIONS_ACTIVE,
  payload: {workSheetWizardSelectionsActive, workSheetWizardSelectionsGroupSelected, workSheetWizardSelectionsClick}
});
